import { render, staticRenderFns } from "./ParticipationROICalculator.vue?vue&type=template&id=a0044ab8&scoped=true"
import script from "./ParticipationROICalculator.vue?vue&type=script&lang=js"
export * from "./ParticipationROICalculator.vue?vue&type=script&lang=js"
import style0 from "./ParticipationROICalculator.vue?vue&type=style&index=0&id=a0044ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0044ab8",
  null
  
)

export default component.exports